/**
 * 基础菜单 商品管理
 */
<template>
  <div >
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>用户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->


    <div class="separators">
      <el-image 
      style="width: 240px; height: 240px;"
    :src="listData.headIcon" 
    @click="adder"
    :preview-src-list="[listData.headIcon]">
  </el-image>
      <!-- <img :src=listData.headIcon alt="" style="width: 240px; height: 240px;"> -->
    <el-descriptions  style=" width: 80%; margin-left: 300px; margin-top: -280px; color: #000; font-size: 20px;" column="4" title="">
    <el-descriptions-item label="UID">{{ listData.id }}</el-descriptions-item>
    <el-descriptions-item label="昵称">{{ listData.nickName }}</el-descriptions-item>
    <el-descriptions-item label="性别">{{  listData.sex==1?'男':"女"}}</el-descriptions-item>
    <el-descriptions-item label="年龄">{{  listData.age}}</el-descriptions-item>
    <el-descriptions-item label="生肖">{{  listData.chineseZodiacDesc}}</el-descriptions-item>
    <el-descriptions-item label="注册天数">{{  listData.registerDayNum}}</el-descriptions-item>
    <el-descriptions-item  label="手机号码">{{  listData.phone|mobileStr}}</el-descriptions-item>
    <el-descriptions-item label="出生日期">{{ listData.birthday|timestampToTimeYMD}}</el-descriptions-item>
  
</el-descriptions>

<el-button round style="margin-top: 250px; " @click="Clickbutton(listData.id)" type="primary">编辑资料</el-button>
<el-button round style="margin-top: 250px; margin-left: 30px;" @click="ClickbuttonZo(listData.mateSelection)" type="success">编辑择偶资料</el-button>
<el-button @click="goBack" type="success" round style=" position: fixed; right: 50px; top: 80px; ">返回上一页</el-button>
<div class="Crda" style=" position: absolute; top: 40px;left: 300px;" >
  <!--  -->
<div v-if="listData.introduction">
  <span>自我介绍:</span>
  <div class="Crda-text">
    {{ listData.introduction }}
  </div>
</div>

  <span>认证情况:</span>
  <div class="Crda-authentication"> 
     <div class="Crda-authChl" v-for="(item,index) in FormData" :key="index">
     <img :src="item.Status==2?item.okimg:item.img" alt="">
     <div class="authChl">{{ item.title }}</div>
     </div>
  

  </div>
</div>

    </div>
<div>
  <el-descriptions style="margin-top: 30px; color: #000; font-size: 20px;" title="TA的账号信息" direction="vertical" column="6" border>
  <el-descriptions-item label="注册时间">{{listData.registerTime |timestampToTime }}</el-descriptions-item>
  <el-descriptions-item label="注册ip">{{ listData.registerIpAddress }}</el-descriptions-item>
  <el-descriptions-item label="注册版本号">{{ listData.version }}</el-descriptions-item>
  <el-descriptions-item label="登录时间">{{ listData.lastLoginTime |timestampToTime }}</el-descriptions-item>
  <el-descriptions-item label="登录ip">{{ listData.loginAddress }}</el-descriptions-item>
  <el-descriptions-item label="最后活跃时间">{{ listData.lastActiveTimeMills|timestampToTime }}</el-descriptions-item>
</el-descriptions>
</div>

  <div>
    <el-descriptions style="margin-top: 50px; color: #000; font-size: 20px;" title="TA的基本信息" direction="vertical" column="8" border>
  <el-descriptions-item label="昵称">{{listData.nickName }}</el-descriptions-item>
  <el-descriptions-item label="性别">{{  listData.sex==1?'男':"女"}}</el-descriptions-item>
  <el-descriptions-item label="出生日期">{{ listData.birthday|timestampToTimeYMD}}</el-descriptions-item>
    <el-descriptions-item label="年龄">{{  listData.age}}</el-descriptions-item>
    <el-descriptions-item label="生肖">{{  listData.chineseZodiacDesc}}</el-descriptions-item>
  <el-descriptions-item label="星座">{{ listData.constellationDesc }}</el-descriptions-item>
  <el-descriptions-item label="身高">{{ listData.height}}{{listData.height?'cm':"" }}</el-descriptions-item>
  <el-descriptions-item label="体重">{{ listData.weight}}{{ listData.weight?'kg':""}}</el-descriptions-item>
  <el-descriptions-item label="民族">{{ listData.nationalityDesc }}</el-descriptions-item>
  <el-descriptions-item label="学历">{{ listData.educationDesc }}</el-descriptions-item>
  <el-descriptions-item label="居住地">{{ listData.registerAddress }}</el-descriptions-item>
  <el-descriptions-item label="家乡">{{ listData.homeAddress }}</el-descriptions-item>
  <el-descriptions-item label="月收入">{{ listData.monthlyIncomeDesc }}</el-descriptions-item>
  <el-descriptions-item label="婚姻状况">{{ listData.maritalStatusDesc }}</el-descriptions-item>
  <el-descriptions-item label="期望结婚时间">{{ listData.expectMarryTimeDesc }}</el-descriptions-item>
  <el-descriptions-item label="有无子女">{{ listData.isHaveChildrenDesc }}</el-descriptions-item>
  <el-descriptions-item label="职业">{{ listData.occupation }}</el-descriptions-item>


  <el-descriptions-item label="购车情况">{{ listData.buyCarStatusDesc }}</el-descriptions-item>
  <el-descriptions-item label="购房情况">{{ listData.buyHouseStatusDesc }}</el-descriptions-item>
  <el-descriptions-item label="是否吸烟">{{ listData.smokeStatusDesc }}</el-descriptions-item>
  <el-descriptions-item label="是否喝酒">{{ listData.drinkStatusDesc }}</el-descriptions-item>
</el-descriptions>
<el-descriptions style="margin-top: 50px; color: #000; font-size: 20px;" title="TA的择偶条件" direction="vertical" column="8" border>
  <el-descriptions-item label="年龄">{{listData.mateSelectionVO.age }}</el-descriptions-item>
  <el-descriptions-item label="月收入">{{ listData.mateSelectionVO.monthlyIncome }}</el-descriptions-item>
  <el-descriptions-item label="学历">{{ listData.mateSelectionVO.education }}</el-descriptions-item>
  <el-descriptions-item label="居住地">{{ listData.mateSelectionVO.address }}</el-descriptions-item>
  <el-descriptions-item label="家乡">{{ listData.mateSelectionVO.homeAddress }}</el-descriptions-item>
  <el-descriptions-item label="职业">{{ listData.mateSelectionVO.occupation }}</el-descriptions-item>
  <el-descriptions-item label="婚姻状况">{{ listData.mateSelectionVO.maritalStatus }}</el-descriptions-item>
  <el-descriptions-item label="期望结婚时间">{{ listData.mateSelectionVO.expectMarryTime }}</el-descriptions-item>
  <el-descriptions-item label="有无子女">{{ listData.mateSelectionVO.isHaveChildren }}</el-descriptions-item>
  <el-descriptions-item label="身高">{{ listData.mateSelectionVO.height }}</el-descriptions-item>
  <el-descriptions-item label="体重">{{ listData.mateSelectionVO.weight }}</el-descriptions-item>
  <el-descriptions-item label="购车情况">{{ listData.mateSelectionVO.buyCarStatus }}</el-descriptions-item>
  <el-descriptions-item label="购房情况">{{ listData.mateSelectionVO.buyHouseStatus }}</el-descriptions-item>
  <el-descriptions-item label="是否吸烟">{{ listData.mateSelectionVO.smokeStatus }}</el-descriptions-item>
  <el-descriptions-item label="是否喝酒">{{ listData.mateSelectionVO.drinkStatus }}</el-descriptions-item>
</el-descriptions>
<el-descriptions style="margin-top: 50px; color: #000; font-size: 20px;" title="TA的他的相册" direction="vertical" column="8" border>
</el-descriptions>


  </div>
  

  <div class="btn-img">
    <div class="nth-child" v-for="(item,index) in listData.albums" :key="index">
    
      <el-image 
    style="  width: 100px;
    height: 100px;
    border-radius: 20px;"
    :src="item" 
    :preview-src-list="listData.albums">
  </el-image>
      <!-- <img :src="item" alt=""> -->
    </div>
  </div>
 
  <div v-if="listData.interestLabel">
    <span style="font-size: 16px;font-weight: 600;">TA的兴趣标签</span>

  <div class="Crda-text" >
    <el-tag   style="margin-left: 10px;margin-top: 10px;font-size: 20px; " type="success"  v-for="(item,index) in listData.interestLabel" :key="index">{{ item }}</el-tag>
  </div>
  </div>
  <el-dialog title="TA的基本资料" :visible.sync="dialogFormVisible">
  <el-form :inline="true" width="800px"  :model="formLIst ">
    <el-form-item label="昵称:" label-width="120px">
      {{ listData.nickName }}
    </el-form-item>
    
  
    
    <el-form-item label="年龄:" label-width="120px">
      {{ listData.age }}
    </el-form-item>

    <el-form-item label="居住地:" label-width="120px">
      {{ listData.registerAddress }}
       
</el-form-item>
<el-form-item label="家乡:" label-width="120px">
      {{ listData.homeAddress }}
       
</el-form-item>
    <el-form-item label="生肖:" label-width="120px">
      {{ listData.chineseZodiacDesc }}
    </el-form-item>
    <el-form-item label="星座:" label-width="120px">
      {{ listData.constellationDesc }}
    </el-form-item><br>
    <el-form-item label="出生日期:" label-width="120px">
      <el-date-picker
      v-model="formLIst.birthday"
      type="date"
      value-format="yyyy-MM-dd"
      placeholder="选择日期时间">
    </el-date-picker>
    </el-form-item>
    <el-form-item label="性别:" label-width="120px">
      <el-select v-model="formLIst.sex" placeholder="不限">
     
      <el-option label="男" :value="1"></el-option>
      <el-option label="女" :value="2"></el-option>
    </el-select>
    </el-form-item>
    <el-form-item label="民族:" label-width="120px">
      <el-select  v-model="formLIst.nationality"  placeholder="不限">
     
      <el-option
      v-for="item in minz"
      :key="item.code"
      :label="item.desc"
      :value="item.code">
    </el-option>
      </el-select>
    </el-form-item>


    <el-form-item label="身高:" label-width="120px">
      <el-input maxlength='3' size="small" type="Number"  clearable  v-model="formLIst.height" placeholder="输入身高">
        <template slot="append">cm</template>
      </el-input>
    </el-form-item>
    <el-form-item label="体重:" label-width="120px">
      <el-input maxlength='3' size="small" type="Number"  clearable  v-model="formLIst.weight" placeholder="输入体重">
        <template slot="append">kg</template>
      </el-input>
    </el-form-item>
    <el-form-item label="学历:" label-width="120px">
      <el-select  v-model="formLIst.education"  placeholder="不限">
     
      <el-option
      v-for="item in xueliX"
      :key="item.code"
      :label="item.desc"
      :value="item.code">
    </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="月收入:" label-width="120px">
      <el-select  v-model="formLIst.monthlyIncome"  placeholder="不限">
     
      <el-option
      v-for="item in shouye2"
      :key="item.code"
      :label="item.desc"
      :value="item.code">
    </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="婚姻状态:" label-width="120px">
      <el-select v-model="formLIst.maritalStatus" placeholder="不限">
      <el-option label="未婚" :value="1"></el-option>
      <el-option label="离异" :value="2"></el-option>
      <el-option label="丧偶" :value="3"></el-option>
    </el-select>
    </el-form-item>
    <el-form-item label="购房情况:" label-width="120px">
      <el-select v-model="formLIst.buyHouseStatus" placeholder="不限">
      <el-option label="未购房" :value="2"></el-option>
      <el-option label="已购房" :value="1"></el-option> 
    </el-select>
    </el-form-item>
    <el-form-item label="购车情况:" label-width="120px">
      <el-select v-model="formLIst.buyCarStatus" placeholder="不限">
      <el-option label="未购车" :value="2"></el-option>
      <el-option label="已购车" :value="1"></el-option> 
    </el-select>
    </el-form-item>
    <el-form-item label="是否吸烟:" label-width="120px">
      <el-select v-model="formLIst.smokeStatus" placeholder="不限">
      <el-option label="从不吸烟" :value="1"></el-option>
      <el-option label="偶尔吸烟" :value="2"></el-option> 
      <el-option label="看应酬吸烟" :value="3"></el-option> 
      <el-option label="经常吸烟" :value="4"></el-option> 
    </el-select>
    </el-form-item>
    <el-form-item label="是否喝酒:" label-width="120px">
      <el-select v-model="formLIst.drinkStatus" placeholder="不限">
      <el-option label="从不喝酒" :value="1"></el-option>
      <el-option label="偶尔喝酒" :value="2"></el-option> 
      <el-option label="看应酬喝酒" :value="3"></el-option> 
      <el-option label="经常喝酒" :value="4"></el-option> 
    </el-select>
    </el-form-item>
    <el-form-item label="期望结婚时间:" label-width="120px">
      <el-select v-model="formLIst.expectMarryTime" placeholder="不限">
    
      <el-option label="半年内" :value="1"></el-option>
      <el-option label="一年内" :value="2"></el-option>
      <el-option label="两年内" :value="3"></el-option>
    </el-select>
    </el-form-item>
      <el-form-item label="有无子女:" label-width="120px">
      <el-select v-model="formLIst.isHaveChildren" placeholder="不限">
   
      <el-option label="没有子女" :value="1"></el-option>
      <el-option label="有子女" :value="2"></el-option>
    </el-select>
    </el-form-item>

    <el-form-item label="职业:" label-width="120px">
      <el-select  v-model="formLIst.occupation"  placeholder="不限">
      <el-option
      v-for="item in testOccupation"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
      </el-select>
    </el-form-item>




     
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogFormVisibleSle">确 定</el-button>
  </div>
</el-dialog>
<!-- 择偶资料 -->
<el-dialog title="择偶条件" :visible.sync="dialogFormVisibleZo">
  <el-form :inline="true" :model="formLIstZo ">

    <el-form-item style="margin-left: 0px;" prop="beginAge" label="年龄:" >
    <el-col :span="4">
      <el-input size="small" type="number" clearable  v-model="formLIstZo.beginAge" placeholder="不限"></el-input>
      <!-- <template slot="append">年龄</template> -->
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <span style="color: red;">0代表不限年龄,修改范围(18-80岁)</span>
    <el-col :span="5">
      <el-form-item prop="endAge" label="">
        <el-input type="number" size="small" clearable  v-model="formLIstZo.endAge" placeholder="不限"></el-input>

        <!-- <template slot="append">年龄</template> -->
      </el-form-item>
      
    </el-col>
  </el-form-item>
  <el-form-item prop="beginAge" label="身高:" >
    <el-col :span="4">
      <el-input type="number" size="small" clearable  v-model="formLIstZo.beginHeight" placeholder="不限"></el-input>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <span style="color: red;">0代表不限身高,修改范围(140-200cm)</span>
    <el-col :span="5">
      <el-form-item prop="endAge" label="">
        <el-input type="number" size="small" clearable  v-model="formLIstZo.endHeight" placeholder="不限"></el-input>
      </el-form-item>
     
    </el-col>
  </el-form-item>
  <el-form-item prop="beginAge" label="体重:" >
    <el-col :span="4">
      <el-input type="number" size="small" clearable  v-model="formLIstZo.beginWeight" placeholder="不限"></el-input>
    </el-col>
    <el-col class="line" :span="2"> &nbsp;&nbsp;&nbsp; -</el-col>
    <span style="color: red;">0代表不限体重,修改范围(30kg-150kg)</span>
    <el-col :span="5">
      <el-form-item prop="endAge" label="">
        <el-input type="number"  size="small" clearable  v-model="formLIstZo.endWeight" placeholder="不限"></el-input>
      </el-form-item>
   
    </el-col>
  </el-form-item>
    <el-form-item label="学历:" label-width="120px">
      <el-select  v-model="formLIstZo.education"  placeholder="不限">
      <el-option
      v-for="item in xueli"
      :key="item.code"
      :label="item.desc"
      :value="item.code">
    </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="月收入:" label-width="120px">
      <el-select  v-model="formLIstZo.monthlyIncome"  placeholder="不限">
     
      <el-option
      v-for="item in shouye1"
      :key="item.code"
      :label="item.desc"
      :value="item.code">
    </el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="婚姻状态:" label-width="120px">
      <el-select v-model="formLIstZo.maritalStatus" placeholder="不限">
        <el-option label="不限" :value="0"></el-option>
      <el-option label="未婚" :value="1"></el-option>
      <el-option label="离异" :value="2"></el-option>
      <el-option label="丧偶" :value="3"></el-option>
     
    </el-select>
    </el-form-item>
    <el-form-item label="期望结婚时间:" label-width="120px">
      <el-select v-model="formLIstZo.expectMarryTime" placeholder="不限">
        <el-option label="不限" :value="0"></el-option>
      <el-option label="半年内" :value="1"></el-option>
      <el-option label="一年内" :value="2"></el-option>
      <el-option label="两年内" :value="3"></el-option>
    </el-select>
    </el-form-item>
      <el-form-item label="有无子女:" label-width="120px">
      <el-select v-model="formLIstZo.isHaveChildren" placeholder="不限">
        <el-option label="不限" :value="0"></el-option>
      <el-option label="没有子女" :value="1"></el-option>
      <el-option label="有子女" :value="2"></el-option>
    </el-select>
    </el-form-item>

    <el-form-item label="职业:" label-width="120px">
      <el-select  v-model="formLIstZo.occupation"  placeholder="不限">
     
      <el-option
      v-for="item in testOccupationis"
      :key="item"
      :label="item"
      :value="item">
    </el-option>
      </el-select>
    </el-form-item>



    <el-form-item label="购房情况:" label-width="120px">
      <el-select v-model="formLIstZo.buyHouseStatus" placeholder="不限">
        <el-option label="不限" :value="0"></el-option>
      <el-option label="未购房" :value="2"></el-option>
      <el-option label="已购房" :value="1"></el-option> 
    </el-select>
    </el-form-item>
    <el-form-item label="购车情况:" label-width="120px">
      <el-select v-model="formLIstZo.buyCarStatus" placeholder="不限">
        <el-option label="不限" :value="0"></el-option>
      <el-option label="未购车" :value="2"></el-option>
      <el-option label="已购车" :value="1"></el-option> 
    </el-select>
    </el-form-item>
    <el-form-item label="是否吸烟:" label-width="120px">
      <el-select v-model="formLIstZo.smokeStatus" placeholder="不限">
        <el-option label="不限" :value="0"></el-option>
      <el-option label="从不吸烟" :value="1"></el-option>
      <el-option label="偶尔吸烟" :value="2"></el-option> 
      <el-option label="看应酬吸烟" :value="3"></el-option> 
      <el-option label="经常吸烟" :value="4"></el-option> 
    </el-select>
    </el-form-item>
    <el-form-item label="是否喝酒:" label-width="120px">
      <el-select v-model="formLIstZo.drinkStatus" placeholder="不限">
        <el-option label="不限" :value="0"></el-option>
      <el-option label="从不喝酒" :value="1"></el-option>
      <el-option label="偶尔喝酒" :value="2"></el-option> 
      <el-option label="看应酬喝酒" :value="3"></el-option> 
      <el-option label="经常喝酒" :value="4"></el-option> 
    </el-select>
    </el-form-item>



    <el-form-item label="居住地:"label-width="100px">
      {{ listData.mateSelectionVO.address }}
</el-form-item>
<el-form-item label="家乡:"label-width="100px">
      {{ listData.mateSelectionVO.homeAddress }}
</el-form-item>
     
  </el-form>
  <div slot="footer" class="dialog-footer">
    <el-button @click="dialogFormVisibleZo = false">取 消</el-button>
    <el-button type="primary" @click="dialogFormVisibleSle(2)">确 定</el-button>
  </div>
</el-dialog>
  </div>
  
</template>

<script>

import Axios from 'axios'


import Vue from 'vue'

import {mobileStr}from "../../utils/util"
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      dialogFormVisible:false,
      dialogFormVisibleZo:false,
       ssoServer:"",
      options1234123:[],
      adder:"",
      testOccupation:[],
      testOccupationis:[],
      srcList: [
        ],
      listData:"",
      minz: [
      {
        "code": 1,
        "desc": "汉族"
      },
      {
        "code": 2,
        "desc": "藏族"
      },
      {
        "code": 3,
        "desc": "朝鲜族"
      },
      {
        "code": 4,
        "desc": "蒙古族"
      },
      {
        "code": 5,
        "desc": "回族"
      },
      {
        "code": 6,
        "desc": "满族"
      },
      {
        "code": 7,
        "desc": "维吾尔族"
      },
      {
        "code": 8,
        "desc": "壮族"
      },
      {
        "code": 9,
        "desc": "彝族"
      },
      {
        "code": 10,
        "desc": "苗族"
      },
      {
        "code": 11,
        "desc": "其他民族"
      }
    ],
    xueli: [
    {
        "code": 0,
        "desc": "不限"
      },
      {
        "code": 1,
        "desc": "中专以下"
      },
      {
        "code": 2,
        "desc": "中专"
      },
      {
        "code": 3,
        "desc": "大专"
      },
      {
        "code": 4,
        "desc": "本科"
      },
      {
        "code": 5,
        "desc": "硕士"
      },
      {
        "code": 6,
        "desc": "博士"
      },
      {
        "code": 7,
        "desc": "博士后"
      }
    ],


    xueliX: [
   
      {
        "code": 1,
        "desc": "中专以下"
      },
      {
        "code": 2,
        "desc": "中专"
      },
      {
        "code": 3,
        "desc": "大专"
      },
      {
        "code": 4,
        "desc": "本科"
      },
      {
        "code": 5,
        "desc": "硕士"
      },
      {
        "code": 6,
        "desc": "博士"
      },
      {
        "code": 7,
        "desc": "博士后"
      }
    ],
    shouye1: [
    {
        "code": 0,
        "desc": "不限"
      },
      {
        "code": 1,
        "desc": "5千以下"
      },
      {
        "code": 2,
        "desc": "5千-1万"
      },
      {
        "code": 3,
        "desc": "1万-2万"
      },
      {
        "code": 4,
        "desc": "2万-3万"
      },
      {
        "code": 5,
        "desc": "3万-5万"
      },
      {
        "code": 6,
        "desc": "5万以上"
      }
    ],
    shouye2: [

      {
        "code": 1,
        "desc": "5千以下"
      },
      {
        "code": 2,
        "desc": "5千-1万"
      },
      {
        "code": 3,
        "desc": "1万-2万"
      },
      {
        "code": 4,
        "desc": "2万-3万"
      },
      {
        "code": 5,
        "desc": "3万-5万"
      },
      {
        "code": 6,
        "desc": "5万以上"
      }
    ],
      formLIst:{
        sex:"",
        expectMarryTime:"",
        education:"",
        isHaveChildren:"",
        birthday:'',
        height:"",
        weight:"",
        buyCarStatus:'',
        buyHouseStatus:'',
        smokeStatus:'',
        drinkStatus:"",
                maritalStatus:"",
        id:"",
        monthlyIncome:"",
        nationality:"",
        registerAddress:"",
        registerIpAddress:"",
        occupation:""
      },
      FormData:[
        {
          img:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/1898344f-e0fd-43eb-bac0-e77ebbd9a689.png',
          okimg:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/6206246d-42b2-4b50-9c24-9cf2f6d74a9b.png',
          title:'实名',
          Status:'',
        },
        {
          img:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/f31278a2-c33a-48ee-bf09-f67eca9017af.png',
          okimg:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/7447763b-5785-44e0-8719-d88a38327a3c.png',
          title:'真颜',
          Status:'',
          
        },
        {
          img:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/f20cc802-d3e9-45ba-bc11-3bdcbf539ec2.png',
          okimg:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/b5a4408b-fec8-431d-927f-e3076cc04f75.png',
          title:'学历',
          Status:'',
        },
        {
          img:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/1a79ad00-217c-4598-93e2-03a0c73b7560.png',
          okimg:'https://online-miniapp-1304146125.cos.ap-beijing.myqcloud.com/3708b3f5-5f1d-4358-bd3c-0e5559726d9a.png',
          title:'工作',
          Status:'',
        },
      ],
      formLIstZo:{
        endAge:"",//结束年龄
        beginAge:'',//开始年龄
        beginHeight:'',
        beginWeight:"",
        education:'',
        endAge:"",
        endHeight:"",
        endWeight:"",
        expectMarryTime:"",
        isHaveChildren:"",
        maritalStatus:"",
        buyCarStatus:"",
        buyHouseStatus:"",
        smokeStatus:'',
        drinkStatus:"",
        monthlyIncome:"",
        occupation:"",
        registerAddress:"",
        registerAddressCode:'',

      },
      formLabelWidth: '120px',
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.ssoServer = Vue.prototype.GLOBAL.ssoServer

    let tokenId= localStorage.getItem('tokenId');
    this.adder =tokenId

    
    // this.formLIst.sex=男
 

    // this.getdata(this.formInline)
  },
   mounted(){
   

Axios({
  method: 'get',

  url: this.ssoServer+'/api/common/getOccupationSelectList',
  headers:{
    tokenId:this.adder
        },
        params:{
       type: 2
  }
    
}).then(res=>{
  
  this.testOccupation =res.data.data
  // this.listData =res.data.data
  // this.formLIst=res.data.data
      
 
})
Axios({
  method: 'get',

  url: this.ssoServer+'/api/common/getOccupationSelectList',
  headers:{
    tokenId:this.adder
        },
        params:{
       type: 1
  }
    
}).then(res=>{
  
  this.testOccupationis =res.data.data
  // this.listData =res.data.data
  // this.formLIst=res.data.data
      
 
})



   this.addrde()


   },
  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    addrde(){
      
    this.getAddresss()
    Axios({
  method: 'get',

  url: this.ssoServer+'/api/platform-account/detail',
  headers:{
    tokenId:this.adder
        },
  params:{
    accountId: this.$route.query.id
  }
    
}).then(res=>{
  this.listData =res.data.data
  this.formLIst.id =res.data.data.id
  this.formLIst.education =res.data.data.education
  this.formLIst.sex =res.data.data.sex
  this.formLIst.height =res.data.data.height
  this.formLIst.weight =res.data.data.weight
  this.formLIst.nationality =res.data.data.nationality
  this.formLIst.monthlyIncome =res.data.data.monthlyIncome
  this.formLIst.maritalStatus =res.data.data.maritalStatus
  this.formLIst.buyHouseStatus =res.data.data.buyHouseStatus
  this.formLIst.buyCarStatus =res.data.data.buyCarStatus
  
  this.formLIst.smokeStatus =res.data.data.smokeStatus
  this.formLIst.drinkStatus =res.data.data.drinkStatus
  this.formLIst.expectMarryTime =res.data.data.expectMarryTime
  this.formLIst.isHaveChildren =res.data.data.isHaveChildren
  this.formLIst.occupation =res.data.data.occupation
  this.formLIst.registerAddress =res.data.data.registerAddress
  this.formLIst.birthday =res.data.data.birthdayStr

  // FormData
  let arr =res.data.data.verifiedStatus
  this.FormData[0].Status=arr.realNameVerifiedStatus
  this.FormData[1].Status=arr.realFaceVerifiedStatus
  this.FormData[2].Status=arr.educationVerifiedStatus
  this.FormData[3].Status=arr.workVerifiedStatus
     
})


    },
    dialogFormVisibleSle(i){
      if(i==2){
        Axios({
        method: 'post',
        url: this.ssoServer+'/api/mate-selection/edit',
        headers:{
    tokenId:this.adder
        },
       
        data:this.formLIstZo
        
      }).then(res => {
        if(res.data.code==0){
          this.dialogFormVisibleZo=false
          this.$message({
          message: '编辑成功',
          type: 'success'
        });
        this.addrde()

        }
        console.log(res);
        // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

      }else{
        Axios({
        method: 'post',
        url: this.ssoServer+'/api/platform-account/edit',
        headers:{
    tokenId:this.adder
        },
        data:this.formLIst
        
      }).then(res => {
        if(res.data.code==0){
          this.dialogFormVisible=false
          this.$message({
          message: '编辑成功',
          type: 'success'
        });
        this.addrde()

        }
        console.log(res);
        // console.log("getAddressList", res.data.data);
        // this.options1234123 = res.data.data

      })

      }
     
     


      

      



    console.log(this.formLIst);
    },
    onChanges(e){
                this.formLIst.registerAddress=e[1]
                  // console.log( this.formInline.registerAddress);
              },
    getAddresss(){
      Axios({
        method: 'get',
        url: this.ssoServer+'/api/common/getAddressList1',
        headers:{
    tokenId:this.adder
        },
      }).then(res => {
        // console.log("getAddressList", res.data.data);
        this.options1234123 = res.data.data

      })
    },

    Clickbutton(id){
      this.dialogFormVisible=true
    

    },
    ClickbuttonZo(item){
      this.formLIstZo=item
      this.dialogFormVisibleZo=true
    

    },
    goBack(){
      if(this.$route.query.index){
        this.$router.push({
    path:"/Eventmanagement/Eventdetails",
    query:{ //query是个配置项
        id:this.$route.query.index
    }
    
})
      }else{

        this.$router.push({
    path:"/goods/UserList",
    
})
      }
    

    },
    // adder(){
    //  this.srcList = this.listData.headIcon
    // },
    handleClose(){

    },

    selectalls(rows){
      // console.log(row);
              //  return console.log("rows : "+JSON.stringify(rows));
                if(rows){
                  rows.forEach(row =>{
                    this.$refs.multipleTable.toggleRowSelection(row);
                  });
                }else{
                    this.$refs.multipleTable.clearSelection();//清除全选
                }
              },


   
    selectall(val){
      this.importList
    console.log(val);
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
      },
    // 导出数据
    imporList(){
      this.dialogVisible=true
    },
    select(selection, row){
      selection.forEach((item)=>{
      
        this.importList=item.id
        // console.log(this.importList);

      })
      
     ;
    },
    resetForm(formInline) {
  //  this.formInline =''
        this.$refs[formInline].resetFields();
      },


   
    // formatData(row, column, cellValue, index){
		
		// //把传过来的日期进行回炉重造一下，又创建了一个js的 Date对象，进行重新构造，转为String字符串
		// //最终返回 s 就可以了
		// var s =	new Date(cellValue).toLocaleString();
	  //   return s;

		//   // 测试参数含义：不知道参数是什么含义的就打印出来
		//   // console.log(row)     	//拿到一行的所有信息，要拿到具体信息,只需要row.XXX 就可以了
		//   // console.log(column)  	//拿到列的信息
		//   // console.log(cellValue) //拿到单元格数据，拿到时间 2022-03-18T01:46:08.000+00:00
		//   // console.log(index)     //拿到索引
	  //   },

    // 获取公司列表
   
    // 分页插件事件
    callFather(parm) {
      console.log(parm);

      this.formInline.size = parm.pageSize
      this.formInline.current = parm.currentPage
      this.formLIst()
    },
    // 搜索事件
    search() {
this.formLIst()
      
      // console.log(this.formInline);
      // this.getdata(this.formInline)
    },
    //显示编辑界面
    handleEdit: function(index, row) {
      this.editFormVisible = true
      if (row != undefined && row != 'undefined') {
        this.title = '修改'
        this.editForm.deptId = row.deptId
        this.editForm.deptName = row.deptName
        this.editForm.deptNo = row.deptNo
      } else {
        this.title = '添加'
        this.editForm.deptId = ''
        this.editForm.deptName = ''
        this.editForm.deptNo = ''
      }
    },
  

  }
}
</script>

<style scoped >
.separators{
  /* width: 100%; */
 
  background-color:#fff;
  margin-top: 30px;
  position: relative;


}
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.box-card {
    width:500px;
    margin-left: 300px;
    margin-top: 30px;
  }
  .Crda{
    width: 70%;
    height: 200px;
    /* background-color: darkblue; */
    position: absolute;
    top: 130px;
    left: 300px;
    /* float: right;
    margin-right: 15%; */
  
  }
  .Crda span{
    font-size: 22px;
font-family: PingFangSC, PingFang SC;
font-weight: 500;
color: #409EFF;

  }
  .Crda-text{
    width: 100%;
    padding: 20px;
 
    margin-top: 0px;
    /* padding: 20px; */
  }
  .Crda-authentication{
    width: 100%;
    height: 85px;
  
    display: flex;
    margin: 15px;
  }
  .Crda-authChl{
    /* flex: 1; */
    width: 80px;
    height: 85px;
    margin-left: 20px;
 
    text-align: center;
    line-height: 100px;
    position: relative;
    
  }
  .Crda-authChl img{
    /* flex: 1; */
    width: 50px;
    height: 50px;
    
    
  }
  .authChl{
    width: 100%;
    height: 20px;
    text-align: center;
    line-height: 20px;
    position: absolute;
    bottom: 0px;
    left: 0;
  }
  .btn-img{
    width: 100%;
    /* height: 200px; */
    /* background-color: darkblue; */
    display: flex;
  }
  .nth-child{
    width: 160px;
    height: 160px;
    margin-left: 20px;
    border-radius: 20px;

  }
  .nth-child img{
    width: 160px;
    height: 160px;
    border-radius: 20px;
  }
</style>

 
 


// WEBPACK FOOTER //
// src/views/goods/userGoods.vue